export default __webpack_public_path__ + "26665b61c2fea726f3200fe2b1bd7f0e.webp";